class PopoutCart extends HTMLElement {
  
  constructor(){
    super();
    this.build();
  }

  build() {
    fetch(window.Shopify.routes.root + '?section_id=stmt-popout-cart')
    .then((res) => {
      return res.text();
    })
    .then((section) => {
      const parser = new DOMParser;
      const popoutCartHtml = parser.parseFromString(section, "text/html");
      const popoutCartSource = popoutCartHtml.querySelector('.js-popout-cart-inner');
      const popoutCartTarget = document.querySelector('.js-popout-cart-items');
    
      if (popoutCartSource && popoutCartTarget) {
        popoutCartTarget.innerHTML = popoutCartSource.outerHTML;
      }

      this.listeners();
      this.bindEmptyCloseEvents();

      if (sessionStorage.getItem('showPopoutCart')) {
        this.showCart();
        sessionStorage.removeItem('showPopoutCart');
      }
    })
    .catch((e) => {
      console.error(e);
    })
  }

  listeners(){
    const closeButtons = document.querySelectorAll('.js-popout-cart-close');
    const popoutCart = this.querySelector('.js-popout-cart');
    const shade = this.querySelector('.js-shade');

    document.addEventListener('popout-cart:show', () => {
      this.showCart();
    });

    document.addEventListener('popout-cart:close', () => {
      this.closeCart();
    });

    closeButtons.forEach((el) => {
      el.addEventListener('click', this.closeCart);
    });

    if (shade) {   
      shade.addEventListener('click', this.closeCart);
    }

    document.addEventListener('cart:requestStart', () => {
      if (popoutCart) {
        popoutCart.scrollTop = 0;
      }
    });

    document.addEventListener('cart:requestComplete', (e) => {this.paintPopoutCart(e)});
    document.addEventListener('cart:updated', this.bindEmptyCloseEvents.bind(this));
  }

  bindEmptyCloseEvents() {
    const cartEmptyButtons = this.querySelectorAll('.js-popout-cart-empty');

    cartEmptyButtons.forEach((el) => {
      el.addEventListener('click', () => {
        this.closeCart();
      });
    })
  }

  showCart() {
    const body = document.querySelector('body');
    body.classList.add('popout-cart-active');
  }

  closeCart() {
    const body = document.querySelector('body');
    body.classList.remove('popout-cart-active');
  }

  paintPopoutCart(e) {
    if (e.detail.data.sections) {
      const popoutCartSection = e.detail.data.sections['stmt-popout-cart'];
      const popoutCartItems = document.querySelector('.js-popout-cart-items');
      
      if (popoutCartSection && popoutCartItems) {
        popoutCartItems.innerHTML = popoutCartSection;
      }
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
}

customElements.define('popout-cart', PopoutCart);
